export class AssertionError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = 'AssertionError';
  }
}

export const assert = (value: boolean, message: string): void => {
  if (!value) throw new AssertionError(message);
};

// enforce rebuild 2026-01-07
